import React from 'react';
import Icon from '../../../components/AppIcon';


const QuoteHeader = ({ quote, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-surface border border-border rounded-lg p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/3 mb-4"></div>
          <div className="h-4 bg-muted rounded w-1/2 mb-2"></div>
          <div className="h-4 bg-muted rounded w-1/4"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface border border-border rounded-lg p-6 mb-6 shadow-soft">
      <div className="flex items-start justify-between mb-6">
        <div className="flex items-center space-x-4">
          <div className="flex items-center justify-center w-12 h-12 bg-primary rounded-lg">
            <Icon name="Calculator" size={24} color="white" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-text-primary">KitchenQuote Pro</h1>
            <p className="text-sm text-text-secondary">Devis de cuisine professionnel</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm text-text-secondary">Devis N°</p>
          <p className="text-lg font-semibold text-text-primary">{quote?.quoteNumber}</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-sm font-semibold text-text-primary mb-3 uppercase tracking-wider">
            Informations Client
          </h3>
          <div className="space-y-2">
            <p className="text-text-primary font-medium">{quote?.client?.name} {quote?.client?.surname}</p>
            <div className="flex items-center space-x-2 text-sm text-text-secondary">
              <Icon name="MapPin" size={14} />
              <span>{quote?.client?.address}</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-text-secondary">
              <Icon name="Phone" size={14} />
              <span>{quote?.client?.phone}</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-text-secondary">
              <Icon name="Mail" size={14} />
              <span>{quote?.client?.email}</span>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-text-primary mb-3 uppercase tracking-wider">
            Détails du Devis
          </h3>
          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-text-secondary">Date de création:</span>
              <span className="text-text-primary font-medium">{quote?.createdDate}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-text-secondary">Valable jusqu'au:</span>
              <span className="text-text-primary font-medium">{quote?.validUntil}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-text-secondary">Catégorie client:</span>
              <span className="text-text-primary font-medium capitalize">{quote?.clientCategory}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-text-secondary">Style de cuisine:</span>
              <span className="text-text-primary font-medium capitalize">{quote?.kitchenStyle}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteHeader;